import constants from "../constants";

const {
  GET_ALL_SERVICES,
  UPDATE_SERVICE,
  UPDATE_SERVICE_STORE,
  UPDATE_ALL_SERVICES_STORE,
  REMOVE_SERVICES,
  REMOVE_SERVICES_STORE,
  GET_SERVICE_EVENTS,
  UPDATE_SERVICE_EVENTS_STORE,
  REMOVE_SERVICE_EVENT,
  REMOVE_SERVICE_EVENT_STORE,
  UPDATE_SERVICE_EVENT,
  UPDATE_SERVICE_EVENT_STORE,
  GET_ALL_SERVICE_CATEGORIES,
  UPDATE_ALL_SERVICES_CATEGORIES_STORE,
  UPDATE_SERVICE_CATEGORY,
  UPDATE_SERVICE_CATEGORY_STORE,
  REMOVE_SERVICE_CATEGORIES,
  REMOVE_SERVICE_CATEGORIES_STORE,
} = constants;

// SERVICES
export const getAllServices = () => ({
  type: GET_ALL_SERVICES,
});

export const updateAllServicesStore = (data) => ({
  type: UPDATE_ALL_SERVICES_STORE,
  data,
});

export const updateService = (data) => ({
  type: UPDATE_SERVICE,
  data,
});

export const updateServiceStore = (serviceData) => ({
  type: UPDATE_SERVICE_STORE,
  serviceData,
});

export const removeServices = (data) => ({
  type: REMOVE_SERVICES,
  data,
});

export const removeServicesStore = (removedIds) => ({
  type: REMOVE_SERVICES_STORE,
  removedIds,
});

// SERVICE CATEGORIES
export const getAllServiceCategories = (data) => ({
  type: GET_ALL_SERVICE_CATEGORIES,
  data,
});

export const updateAllServicesCategoriesStore = (data) => ({
  type: UPDATE_ALL_SERVICES_CATEGORIES_STORE,
  data,
});

export const updateServiceCategory = (data) => ({
  type: UPDATE_SERVICE_CATEGORY,
  data,
});

export const updateServiceCategoryStore = (serviceCategoryData) => ({
  type: UPDATE_SERVICE_CATEGORY_STORE,
  serviceCategoryData,
});

export const removeServiceCategories = (data) => ({
  type: REMOVE_SERVICE_CATEGORIES,
  data,
});

export const removeServiceCategoriesStore = (removedIds) => ({
  type: REMOVE_SERVICE_CATEGORIES_STORE,
  removedIds,
});

// SERVICE EVENTS
export const getServiceEvents = () => ({
  type: GET_SERVICE_EVENTS,
});

export const updateServiceEventsStore = (data) => ({
  type: UPDATE_SERVICE_EVENTS_STORE,
  data,
});

export const updateServiceEvent = (data) => ({
  type: UPDATE_SERVICE_EVENT,
  data,
});

export const updateServiceEventStore = (data) => ({
  type: UPDATE_SERVICE_EVENT_STORE,
  data,
});

export const removeServiceEvent = (data) => ({
  type: REMOVE_SERVICE_EVENT,
  data,
});

export const removeServiceEventStore = (data) => ({
  type: REMOVE_SERVICE_EVENT_STORE,
  data,
});
